import React from "react";

type SectionSubheadingProps = {
    text: string;
};

export default function SectionSubheading({ text }: SectionSubheadingProps) {
    return (
        <p className="w-full lg:w-[530px] font-regular text-lg md:text-[20px] lg:text-xl text-text-700">
            {text}
        </p>
    );
}
